import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0%, 80%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: var(--color-medium-purple);
  border-radius: 50%;
  animation: ${blink} 1.4s infinite both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }

  @media (min-width: 768px) {
    width: 12px;
    height: 12px;
    margin: 0 6px;
  }

  @media (min-width: 1024px) {
    width: 16px;
    height: 16px;
    margin: 0 8px;
  }
`;

const LoadingDots = () => {
  return (
    <LoadingContainer>
      <Dot />
      <Dot />
      <Dot />
    </LoadingContainer>
  );
};

export default LoadingDots;
